// ==========================================================================
// components/DueSoon.tsx — bills and reminders due soon, on Home (FF-056)
// ==========================================================================
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useContacts } from "@/lib/contacts";
import { money } from "@/lib/money";
import { billPending, useReceipts } from "@/lib/receipts";
import { daysTo, dueText, kindOf, useDoneReminder, useReminders } from "@/lib/reminders";

export default function DueSoon() {
  const receipts = useReceipts(); const reminders = useReminders(); const contacts = useContacts(); const done = useDoneReminder();
  const bills = (receipts.data ?? []).filter((r) => billPending(r) && r.due_on && daysTo(r.due_on) <= 14)
    .map((r) => ({ key: `b${r.id}`, emoji: "🧾", title: (contacts.data ?? []).find((c) => c.id === r.contact_id)?.name ?? r.note ?? "A bill", due: r.due_on!, amount: r.total_cents, rem: null }));
  const rems = (reminders.data ?? []).filter((r) => !r.done_on && daysTo(r.due_on) <= r.warn_days)
    .map((r) => ({ key: `r${r.id}`, emoji: kindOf(r.kind).emoji, title: r.title, due: r.due_on, amount: r.amount_cents, rem: r }));
  const list = [...bills, ...rems].sort((a, b) => a.due.localeCompare(b.due)).slice(0, 6);
  if (!list.length) return null;
  return (
    <section className="rounded-lg bg-surface shadow-soft ring-1 ring-line/70">
      <div className="flex items-center justify-between px-5 pb-2 pt-5">
        <h2 className="text-[17px] font-semibold">Due soon</h2>
        <Link to="/bills" className="text-sm font-semibold text-primary">Bills and reminders</Link>
      </div>
      <ul className="px-2 pb-3">
        {list.map((x) => {
          const n = daysTo(x.due);
          return (
            <li key={x.key} className="flex items-center gap-3 rounded-md px-3 py-2.5">
              <span className="text-xl">{x.emoji}</span>
              <span className="min-w-0 flex-1"><span className="block truncate text-[15px]">{x.title}</span><span className={`text-xs ${n < 0 ? "font-semibold text-bad" : n <= 3 ? "text-warn" : "text-ink-muted"}`}>{dueText(x.due)}</span></span>
              {x.amount ? <span className="num text-sm font-semibold">{money(x.amount)}</span> : null}
              {x.rem && <button type="button" onClick={() => done.mutate(x.rem!)} aria-label="Done" className="rounded-full p-1.5 text-ink-muted hover:bg-good/15 hover:text-good"><Check className="h-4 w-4" /></button>}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
